import type { Dispatch, SetStateAction } from 'react';
import { useFormApi } from 'informed';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { TextField } from '@calefy-inc/informedMaterial';
import { mergeExistingKeywordsWithNew } from './utility';
// types and classes

interface BusinessTypeAliasesProps {
  aliases: Array<string>;
  setAliases: Dispatch<SetStateAction<Array<string>>>;
}
export const BusinessTypeAliases = ({
  aliases,
  setAliases,
}: BusinessTypeAliasesProps) => {
  const formApi = useFormApi();
  return (
    <>
      <TextField
        name='aliases'
        label='Enter a comma-separated list of aliases for the business. These will appear as separate businesses in the selection page.'
        fullWidth
        variant='outlined'
        onBlur={
          // @ts-expect-error
          ({ value: newAliases }) => {
            if (typeof newAliases === 'string' && newAliases.trim() !== '') {
              setAliases((oldAliases) =>
                mergeExistingKeywordsWithNew(oldAliases, newAliases),
              );
            }
            formApi.setValue('aliases', '');
          }
        }
      />
      {aliases.length > 0 ? (
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={{ xs: 3, sm: 2 }}
        >
          {aliases.map((alias) => (
            <Chip
              key={alias}
              label={alias}
              variant='outlined'
              onDelete={() =>
                setAliases((oldAliases) =>
                  oldAliases.filter((oldAlias) => oldAlias !== alias),
                )
              }
            />
          ))}
        </Stack>
      ) : null}
    </>
  );
};
